<template>
  <div
    class="container"
    :style="{
      left: `${offset.x}px`,
      top: `${offset.y}px`
    }"
  >
    <div
      v-for="(data, index) in list"
      :key="index"
      class="cursorView"
      :style="{
        left: `${(data.x + 105) * widthAmp}px`,
        top: `${(data.y + 105) * widthAmp}px`
      }"
    >
      <div class="cursorView__icon"></div>
    </div>
  </div>
</template>

<script>
import API from "../../api/API";

export default {
  name: "OtherUsers",
  props: ["offset"],
  data() {
    return {
      list: [],
      widthAmp: 0.5,
      timer: null
    };
  },
  mounted() {
    // this.widthAmp = window.innerWidth / 1920;
  },
  methods: {
    async getCursors() {
      const result = await API.getCursors(this.$store.state.concert.concertId);
      if (result.data) {
        const max = 100;
        if (result.data.length > max) {
          this.list = result.data.slice(0, max);
        } else {
          this.list = result.data;
        }
        return result;
      }
    },
    async start() {
      this.isShow = true;
      this.fetch();
    },
    async fetch() {
      if (!this.isShow)
        return;
      this.killTimer();
      const result  = await this.getCursors();
      this.timer = setTimeout(()=>{
        this.fetch();
      }, 10 * 1000)
    },
    hide() {
      this.isShow = false;
      this.list = [];
      this.killTimer();
    },
    killTimer() {
      if (this.timer) clearTimeout(this.timer);
      this.timer = null;
    }
  }
};
</script>

<style scoped lang="sass">
.cursorView
    position: absolute
    animation: cursorAnim .5s infinite cubic-bezier(0.000, 0.615, 0.000, 1) alternate-reverse

    .cursorView__icon
        background: url("../../assets/ui/spray-other.png") 0 0 no-repeat
        background-size: contain
        width: 46px
        height: 48px
        transform: translate(-23px, -24px)
.container
    position: absolute
    height: 540px


@keyframes cursorAnim
    0%
        transform: translateY(0)
    100%
        transform: translateY(-15px)
</style>
